import api from "../../index";
import { IChangeCompany, ITranslite, IUpdateCompanyData } from "@/api/mainPage/company/interface";
import auth from "@/models/modules/auth";
import { authEntity } from "@/models/modules/auth/entity";

export const $getCustomerCompany = async (v?: ITranslite): Promise<IUpdateCompanyData> => {
	// return require('./mock/customer-profile.json').data;

	return api
		.get("customer/profile", {
			request: { params: v }
		})
		// .then(r => r || []);
};

export const $changeCustomerCompany = (v: IChangeCompany): Promise<boolean> => api
	.post("customer/change-corp-identity", {
		accessToken: authEntity.accessToken,
		refreshToken: authEntity.refreshToken,
		...v
	})
	.then(r => {
		auth.signIn(r);
		return authEntity.isAuth;
	});
